import axios from 'axios'
import * as md5 from 'md5'
import stringify from 'qs/lib/stringify'
import config from 'common/config'
import storage from 'src/unit/storage'
import store from 'store'

const host = config.api.host // java源
const pythonHost = config.api.pythonHost // python源
let currentHost = pythonHost
let $Vue = null

// build http header
function buildHeader(option) {
    let headers = {
        // 'X-Application-Key': config.api.key,
        // 'X-Request-Sign': '',
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        // 'Content-Type': 'application/json; charset=utf-8'
    }
    if (option) {
        if (option.timeout) {
            delete option.timeout
        }
        headers = { ...headers, ...option }
    }
    if (currentHost === host) { // 临时处理，java全部代替Python得重改
        headers.token = store.state.user.token || null
    }
    return headers
}

function handleError (err) {
    // 如果是手动取消的请求，不显示错误信息
    if (axios.isCancel(err)) {
        console.log(err)
    } else {
        let msg = err || '发生未知错误，请重试'
        if (('' + msg).indexOf('timeout') > -1) {
            msg = '加载超时！请检查你的网络设备'
        }
        $Vue.$vux.toast.show({
            text: ('' + msg).replace(/Error:/g, ''),
            type: 'text',
            width: '10em'
        })
        console.error(err)
    }
}


// axios配置
let axiosConfig = (option = {timeout: 10000}) => {
    return {
        baseURL: currentHost,
        headers: buildHeader(option),
        timeout: option.timeout,
        responseType: 'json',
        transformRequest: [function (data) {
            if (data instanceof FormData) {
                return data
            } else {
                return data
            }
        }],
        transformResponse: [function (data) {
            return transformResponse(data)
        }]
    }
}


function processGetData(apiData = {}) {
    let data = { ...apiData }
    let token = store.state.user.token
    let userMsg = store.state.user.userMsg
    let params = {}
    if (!token) {
        params = {data: JSON.stringify(data)}
    } else {
        params = {
            data: JSON.stringify(data),
            token: token,
            check_code: userMsg.check_code
        }
    }

    return params
}

function processData(apiData = {}) {
    let data = { ...apiData }
    let token = store.state.user.token
    let userMsg = store.state.user.userMsg
    let params = {}
    if (currentHost === host) {
        params = JSON.stringify(data)
    } else {
        if (!token) {
            params = stringify({
                data: JSON.stringify(data)
            })
        } else {
            params = stringify({
                data: JSON.stringify(data),
                token: token,
                check_code: userMsg.check_code
            })
        }
    }

    return params
}

function processFormData(formData = {}) {
    let data = formData.file
    let token = store.state.user.token
    let userMsg = store.state.user.userMsg

    data.append('token', token)
    data.append('check_code', userMsg.check_code)

    return data
}

function transformResponse(data) {
    if (data) {
        if (data.code === 0) {
            let res = data.data
            return res
        } else if (data && (data.code === 1003 || data.code === 1004)) {
            // 登录过期
            $Vue.$vux.toast.show({
                text: '登录过期，请重新登录',
                type: 'text'
            })
            // 执行一次登出操作，清除登录信息
            store.dispatch('user/logout')
            throw new axios.Cancel('登录过期，请重新登录')
        } else {
            let msg = data.msg || '发生未知错误，请重试'
            handleError(msg)
            throw new Error(msg)
        }
    } else {
        let msg = '发生未知错误，请重试'
        handleError(msg)
        throw new Error(msg)
    }
}

// http get method
export function get(url, data = {}, hostType) {
    let option = {
    }
    if (data && data.timeout) {
        option.timeout = data.timeout
    }
    currentHost = hostType === 'javaHost' ? host : pythonHost

    let nax = axios.create(axiosConfig(option))
    if (hostType === 'javaHost') {
        return nax.get(`${currentHost}${url}` + '?' + stringify(data)).then((res) => {
            return res.data
        }).catch((err) => {
            throw err
        })
    } else {
        let id = data.id ? '/' + data.id : ''
        return nax.get(`${currentHost}${url}${id}`, {params: processGetData(data)}).then((res) => {
            return res.data
        }).catch((err) => {
            throw err
        })
    }
}

// http post method
export function post(url, data = {}, hostType) {
    let option = {}
    if (data.timeout) {
        option.timeout = data.timeout
    }
    let id = data.id ? '/' + data.id : ''
    if (hostType === 'javaHost') {
        option['Content-Type'] = 'application/json;charset=utf-8'
        currentHost = host
        id = ''
    } else {
        currentHost = pythonHost
    }

    let nax = axios.create(axiosConfig(option))
    return nax.post(`${currentHost}${url}${id}`, processData(data)).then((res) => {
        return res.data
    }).catch((err) => {
        throw err
    })
}

// http put method
export function put(url, data = {}) {
    let option = {}
    if (data.timeout) {
        option.timeout = data.timeout
    }
    let id = data.id ? '/' + data.id : ''
    currentHost = pythonHost

    let nax = axios.create(axiosConfig(option))
    return nax.put(`${currentHost}${url}${id}`, processData(data)).then((res) => {
        return res.data
    }).catch((err) => {
        throw err
    })
}

// http delete method
export function del(url, data = {}) {
    let option = {}
    if (data.timeout) {
        option.timeout = data.timeout
    }
    let id = data.id ? '/' + data.id : ''
    currentHost = pythonHost
    let nax = axios.create(axiosConfig(option))
    return nax.delete(`${currentHost}${url}${id}` + '?' + processData(data)).then((res) => {
        return res.data
    }).catch((err) => {
        throw err
    })
}

// post form-data
export function postFormData(url, data, hostType) {
    let option = {
        'Content-Type': 'multipart/form-data'
    }
    if (data.timeout) {
        option.timeout = data.timeout
    }
    currentHost = hostType === 'javaHost' ? host : pythonHost

    let nax = axios.create(axiosConfig(option))
    return nax.post(`${currentHost}${url}`, processFormData(data)).then((res) => {
        return res.data
    }).catch((err) => {
        throw err
    })
}

// xhr上传附件
export function xhrUpload(type, data, callback) {
    console.log('---http--xhrUpload---')
    // let xhr = new XMLHttpRequest()
    // xhr.open('post', currentHost + '/upload/' + type + '/' + storage.get('token'), true)
    // xhr.send(data)
    // xhr.onload = function () {
    //     callback(JSON.parse(xhr.responseText))
    // }
}

export default function (Vue) {
    $Vue = Vue
}



// WEBPACK FOOTER //
// ./src/api/http.js